import {
    BadActivecon,
    BadIcon,
    GoodActiveIcon,
    GoodIcon,
    NormalActiveIcon,
    NormalIcon,
} from "src/assets/icons";
import { getUrlAndQueryParams, msgDevWarning } from "src/utils";

export interface ResponseData<T> {
    msg: string;
    code: number;
    data: T;
    total?: number;
}

const currentDomain = getUrlAndQueryParams().pathArray[0]; 
const isLocal = currentDomain.indexOf("localhost") >= 0 || currentDomain.indexOf("taint") >= 0;
const isDev = currentDomain.indexOf("dev-") >= 0;
const isProd = !isDev && !isLocal;

export const DOMAIN_API_URL = isProd ?  "https://chatbot.fiza.ai" :  "https://dev-chatbot.fiza.ai";

if (isProd) {
    msgDevWarning();
    console.log = function () { };
}
console.log('current:' + currentDomain);
export const ENV = {
    PROD: isProd,
    LOCAL: isLocal,
    DOMAIN_API_URL: isProd ? "https://chatbot.fiza.ai/api/v1/" : "https://dev-chatbot.fiza.ai/api/v1/"
};

export const API = {
    GET: {
        JOB_LIST: "/job/list",

        SETTING: ENV.DOMAIN_API_URL + "widget/setting",
    },
    POST: {
        TRACKING: "/track",
        POST_JOB_TITLE: "/job/gen",
        POST_CHAT_ZNS: "/oachat/znsbot/api/chat_widget",

        CHAT_WIDGET: ENV.DOMAIN_API_URL + "chat/widget",
        ZCATRACKING: 'https://openapi.zalo.cloud/v1/track',
    },
};

export enum SENDER_TYPE {
    ME = "me",
    REMOTE = "remote",
}

export const MAP_AVATAR_DEFAULT = {
    [SENDER_TYPE.ME]:
        "https://stc-oa.zdn.vn/uploads/2023/05/19/ecacb202352d011de0f0c3647f7ba5d3.png",
    [SENDER_TYPE.REMOTE]:
        "https://stc-oa.zdn.vn/resources/zbilling/static/images/favicon.ico",
};

export enum EMOJI_TYPE {
    GOOD = 1,
    NORMAL = 2,
    BAD = 3,
}

export const URL_ICONS =
    "https://stc-oa.zdn.vn/resources/zchat-ai/assets/icons";

export const MAP_EMOJI = [
    {
        type: EMOJI_TYPE.GOOD,
        icon: `${URL_ICONS}/ic-good-1.svg`,
        iconActive: `${URL_ICONS}/ic-good-active-1.svg`,
    },
    {
        type: EMOJI_TYPE.NORMAL,
        icon: `${URL_ICONS}/ic-normal-1.svg`,
        iconActive: `${URL_ICONS}/ic-normal-active-1.svg`,
    },
    {
        type: EMOJI_TYPE.BAD,
        icon: `${URL_ICONS}/ic-bad-1.svg`,
        iconActive: `${URL_ICONS}/ic-bad-active-1.svg`,
    },
];

export const TRACKING_TYPE = {
    ACCESS: 100,
    CLOSE: 101,
    COMMENT: 102,
    RATING: 103,
};
